import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const appraiserTransactionTypeMap: Record<AppraiserTransactionType, MapItem> = {
  purchase: { label: 'Purchase' },
  refinance: { label: 'Refinance' },
  estate_planning: { label: 'Estate Planning' },
  divorce_settlement: { label: 'Divorce Settlement' },
  tax_assessment_appeal: { label: 'Tax Assessment Appeal' },
  home_equity_heloc: { label: 'Home Equity Loan or Line of Credit (HELOC)' },
  heloc_appraisal: { label: 'Appraisal for securing a HELOC or home equity' },
  pre_listing: { label: 'Pre-Listing' },
  insurance_valuation: { label: 'Insurance Valuation' },
  other: { label: 'Other' },
}

// Schema that includes both the type and optional custom value
export const appraiserTransactionTypeSchema = z.enum(
  Object.keys(appraiserTransactionTypeMap) as [AppraiserTransactionType, ...AppraiserTransactionType[]],
)

export type AppraiserTransactionType =
  | 'purchase'
  | 'refinance'
  | 'estate_planning'
  | 'divorce_settlement'
  | 'tax_assessment_appeal'
  | 'home_equity_heloc'
  | 'heloc_appraisal'
  | 'pre_listing'
  | 'insurance_valuation'
  | 'other'

export type AppraiserTransactionTypeWithCustom = z.infer<typeof appraiserTransactionTypeSchema>
